import CkeditorComponentV2 from 'component/ckeditor/indexV2'
import React from 'react'

export default function InputRaporBlockAllNoteSpecialAdditional({ note, setNote }) {
  return (
    <div className="mx-5 mb-5">
      <h5>Catatan Guru Orthopedagog / BK</h5>
      <CkeditorComponentV2
        data={note || ''}
        onChange={setNote}
        otherConfigs={{
          placeholder: 'Catatan Guru Orthopedagog / BK'
        }}
      />
    </div>
  )
}
